import { config } from "@app-contexts/sdk/services/config";
import {
  type Widget,
  type WidgetQueryParams,
} from "@app-contexts/sdk/services/Widget";
import { queryParamSerializer } from "@shared/utils/url";

/**
 * @deprecated no longer supported in v2
 */
export async function loginWidget(
  params: WidgetQueryParams
): Promise<Widget | null> {
  const queryString = queryParamSerializer(params);
  const url = `${await config.loginWidgetUrl()}?${queryString}`;
  const popup = window.open(url, "", "width=400,height=700");

  window.addEventListener("message", () => {
    popup?.close();
  });

  return null;
}
